/**
 * One "start from" row of the create panel: a short label, a searchable
 * pick and the button that acts on it — disabled until something is picked.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, useState } from 'react';

import { Button, SearchableSelect, type SearchableSelectOption } from '@/components/ui';

interface Props {
  label: string;
  placeholder: string;
  options: SearchableSelectOption<string>[];
  action: string;
  onGo: (value: string) => void;
}

export const PickAndGo: FC<Props> = ({ label, placeholder, options, action, onGo }) => {
  const [value, setValue] = useState('');
  return (
    <div className="flex flex-col gap-1.5 border-t border-border pt-3">
      <span className="text-xs text-muted-foreground">{label}</span>
      <div className="flex items-center gap-2">
        <div className="min-w-0 flex-1">
          <SearchableSelect options={options} value={value} onChange={(v) => setValue(String(v))} placeholder={placeholder} />
        </div>
        <Button variant="outline" size="sm" disabled={!value} onClick={() => onGo(value)}>
          {action}
        </Button>
      </div>
    </div>
  );
};
